import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: 'app-edit-trust-report-dialog',
  templateUrl: './editTrustReportDialog.component.html'
})
export class EditTrustReportDialogComponent {
  reportForm: FormGroup;

  constructor(
    private _formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<EditTrustReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { name: string }
  ) {
    this.reportForm = this._formBuilder.group({
      name: [data.name || '', Validators.required]
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onSave() {
    if (this.reportForm.valid) {
      console.log("Changing name to ", this.reportForm.value.name);
      this.dialogRef.close(this.reportForm.value.name);
    }
  }
}
